import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import AgoraClient from '@/assets/js/rtc-client-ng';
import { handleLocalStorage } from '@/assets/js/utils.js';
const nodeUrl = require('url');
export default {
  data() {
    return {
      sendBtnColor: '',
      sourceType: '',
      name: 'thomas',
      partyList: [],
      partyListInfo: {},
      currentPage: 1,
      receiverNickname: '',
      partyCode: '',
      partyInfo: {},
      behaviorInfo: {},
      mainWindowList: [{
        label: 'Source type',
        options: [{
          value: 'VFB',
          label: 'VFB (Receiver Video Return)'
        }, {
          value: 'PP',
          label: 'PP (Producer)'
        }, {
          value: 'Tag',
          label: 'Tag'
        }]
      }],
      rtc: null,
      devicePlatform: {},
      channels: {},
      mutePartyList: [],
      muteAudioObj: {},
      partyListParams: {
        pageNum: 1,
        pageSize: 12,
        globalControlId: ''
      },
      settingPopupInfo: {
        show: false
      },
      selectAll: false,
      partyExpand: [],
      movePartyInfo: {
        show: false,
        partyInfo: {}
      },
      userInfo: {
        joinCode: ''
      },
      isSelectAll: false,
      globalControlInfoTips: {
        show: false,
        title: 'kioskHost.addToGlobalControl',
        cancel: 'commonFunction.cancel',
        save: 'Movepips.save',
        edit: false
      },
      globalName: '',
      showEmptyName: false,
      selectPartyList: [],
      kioskPartyList: []
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      GlobalControlId: state => state.globalControlId,
      currentPartyInfo: state => state.currentPartyInfo,
      logoGray: state => state.logoGray
    }),
    returnMuteClass() {
      let _str = '';
      if (!this.mutePartyList.length || this.mutePartyList.length == this.partyList.length) {
        _str = 'green';
      } else {
        _str = 'blue';
      }
      if (!this.GlobalControlId) _str += ' gray';
      for (const partyCode in this.movePartyInfo.partyInfo) {
        this.partyList.forEach(item => {
          if (item.partyCode == partyCode && !item.checked && this.movePartyInfo.partyInfo[partyCode].rtilCodes.length > 0) {
            _str += ' gray';
          }
        });
      }
      return _str;
    },
    returnNumber() {
      if (this.globalControlInfoTips.edit) {
        let selectNumber = 0;
        this.kioskPartyList.forEach(item => {
          if (item.checked && (!item.belongToGlobalControl || item.belongToGlobalControl == 2)) {
            selectNumber++;
          }
        });
        return selectNumber;
      } else {
        return this.selectPartyList.length;
      }
    },
    leftButtonText() {
      const _str = !this.mutePartyList.length || this.mutePartyList.length == this.partyList.length ? this.$t('kioskHost.muteAllMic') : this.$t('kioskHost.muteMic');
      return _str;
    },
    rightButtonText() {
      const _str = !this.mutePartyList.length || this.mutePartyList.length == this.partyList.length ? this.$t('kioskHost.unmuteAllMic') : this.$t('kioskHost.unmute');
      return _str;
    },
    judgeMuteButton() {
      let flag = false;
      if (!this.GlobalControlId) return true;
      for (const partyCode in this.movePartyInfo.partyInfo) {
        this.partyList.forEach(item => {
          if (item.partyCode == partyCode && !item.checked && this.movePartyInfo.partyInfo[partyCode].rtilCodes.length > 0) {
            flag = true;
          }
        });
      }
      return flag;
    }
  },
  watch: {
    'currentPartyInfo.id'(globalControlId) {
      if (!globalControlId) return;
      this.partyListParams.globalControlId = globalControlId;
      this.State.globalControlId = globalControlId;
      this.defaultSet();
      this.dealGlobalList();
      this.userInfo.joinCode = globalControlId;
      Bus.$emit('createWs', {
        ...this.State.config,
        partyCode: '',
        globalControlId
      });
      // 根据当前的 partyCode 来执行要不要 join 方法
      if (this.currentPartyInfo.partyCode) {
        this.getGlobalAgoraToken(this.currentPartyInfo.partyCode);
      }
    }
  },
  created() {
    /**
     * @params 重构新加代码开始
     */
    const URL = nodeUrl.parse(location.href, true);
    this.partyListParams.globalControlId = URL.query.id;
    this.getGlobalControlInfo(URL.query.id);
    /**
     * @params 重构新加代码结束
     */
    Bus.$on('startPushStreamFromGlobalControl', v => {
      const {
        output,
        outputType,
        partyCode,
        sourceType
      } = v;
      this.currentPartyInfo.outputType === outputType;
      this.currentPartyInfo.output = output;
      // 如果 rtc 没有值则表示这是第一次推流，需要先加入 Agora
      if (!this.rtc && sourceType != 'Tag') {
        this.getGlobalAgoraToken(partyCode);
      }
    });
    Bus.$on('stopPushStreamFromGlobalControl', v => {
      this.currentPartyInfo.outputType === '';
      this.currentPartyInfo.output = '';
    });
    Bus.$on('updateTableList', info => {
      const {
        type,
        index
      } = info;
      if (type === 'add') {
        this.dealGlobalList();
      } else if (type === 'delete') {
        this.defaultSet();
      } else {
        this.partyList.splice(index, 1);
      }
    });
    Bus.$on('muteFromGlobalControl', result => {
      const {
        partyCodes,
        operateType
      } = result;
      if (!partyCodes.length) {
        if (operateType) {
          this.partyList.forEach(item => {
            item.microphoneStatus = 1;
          });
        } else {
          this.partyList.forEach(item => {
            item.microphoneStatus = 0;
          });
        }
      } else {
        if (operateType) {
          this.partyList.forEach(item => {
            if (partyCodes.includes(item.partyCode)) {
              item.microphoneStatus = 1;
            }
          });
        } else {
          this.partyList.forEach(item => {
            if (partyCodes.includes(item.partyCode)) {
              item.microphoneStatus = 0;
            }
          });
        }
      }
    });
    Bus.$on('changePartyName', v => {
      const {
        partyCode,
        name
      } = v;
      this.partyList.forEach(item => {
        if (item.partyCode == partyCode) {
          item.name = name;
        }
      });
    });
  },
  methods: {
    getGlobalControlInfo(globalControlId) {
      if (!globalControlId) return;
      this.axios.post('/partyline-backend/globalControl/pageInfo', {
        pageNum: 1,
        pageSize: 100,
        globalControlId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const result = res.data.result;
          if (result.mainWindowSetting) {
            result.mainWindowSetting.vfbResolution = result.mainWindowSetting.resolution;
            result.mainWindowSetting.vfbFrameRate = result.mainWindowSetting.frameRate;
            result.mainWindowSetting.vfbBitrate = result.mainWindowSetting.bitrate;
            result.mainWindowSetting.volume = result.mainWindowSetting.volume;
          }
          this.State.currentPartyInfo = {
            ...result,
            status: {},
            code: globalControlId,
            globalControlId
          };
          Bus.$emit('changePartyAddress', {
            currentId: globalControlId,
            lastId: '',
            init: 'initAside',
            title: result.name,
            id: globalControlId
          });
        }
      });
    },
    blurName() {
      if (!this.globalName) {
        this.showEmptyName = true;
      } else {
        this.showEmptyName = false;
      }
    },
    returnDisabled(item) {
      if (this.globalControlInfoTips.edit) {
        if (item.belongToGlobalControl == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (item.belongToGlobalControl) {
          return true;
        } else {
          return false;
        }
      }
    },
    returnClass(item) {
      let _str = '';
      if (this.globalControlInfoTips.edit) {
        if (item.belongToGlobalControl != 1 && item.checked) {
          _str = 'select';
        }
      } else {
        if (!item.belongToGlobalControl && item.checked) {
          _str = 'select';
        }
      }
      return _str;
    },
    saveControl() {
      if (!this.globalName) {
        this.showEmptyName = true;
        return;
      }
      this.globalControlInfoTips.show = false;
      if (this.globalControlInfoTips.edit) {
        this.updateGlobalControl();
      }
    },
    updateGlobalControl() {
      const addParty = [];
      const removeParty = [];
      const selectPartyList = [];
      this.selectPartyList.forEach(item => {
        selectPartyList.push(item.partyCode);
      });
      this.kioskPartyList.forEach(item => {
        if (!item.belongToGlobalControl && selectPartyList.includes(item.partyCode)) {
          addParty.push(item.partyCode);
        }
        if (item.belongToGlobalControl == 2 && item.checked == false) {
          removeParty.push(item.partyCode);
        }
      });
      const params = {
        id: this.State.globalControlId,
        name: this.globalName,
        appendPartyCodes: addParty,
        removePartyCodes: removeParty
      };
      this.axios.post('/partyline-backend/globalControl/update', params).then(async res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.selectPartyList = [];
          this.$message.success(this.$t('mainWindow.success'));
          this.dealGlobalList();
          Bus.$emit('changeTitle', this.globalName);
          // Bus.$emit('updateTableList', { type: 'add' })
        }
      });
    },

    async getPartyPage() {
      let array = [];
      this.partyListLoading = true;
      await this.axios.post('/partyline-backend/globalControl/pageInfo', {
        pageNum: 1,
        pageSize: 100,
        globalControlId: this.State.globalControlId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          array = res.data.result.pageInfoVo.list;
          array.forEach(item => {
            item.globalControlId = this.State.globalControlId;
            item.id = item.partyCode;
            item.editName = item.name;
          });
        }
        this.partyListLoading = false;
      });
      return array;
    },
    getKioskPartyList() {
      const params = {
        globalControlId: this.State.globalControlId,
        pageSize: 100,
        pageNum: 1,
        sortField: '',
        sortDirection: ''
      };
      this.axios.post('/partyline-backend/kiosk/page', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          res.data.result.list.forEach(item => {
            if (item.belongToGlobalControl == 1 || item.belongToGlobalControl == 2) {
              item.checked = true;
            } else {
              item.checked = false;
            }
          });
          this.kioskPartyList = res.data.result.list;
        }
      });
    },
    // 用来保存要添加的 party
    savePartyInfo(val, item) {
      if (val) {
        item.checked = true;
        this.selectPartyList.push(item);
      } else {
        item.checked = false;
        this.selectPartyList.forEach((item1, index) => {
          if (item.partyCode == item1.partyCode) {
            this.selectPartyList.splice(index, 1);
          }
        });
      }
    },
    showSettingDialog() {
      this.settingPopupInfo.show = true;
    },
    closeSettingDialog() {
      this.settingPopupInfo.show = false;
    },
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.partyListParams.pageNum = 1;
      this.partyListParams.pageSize = pageSize;
      this.dealGlobalList();
    },
    handleCurrentChange(pageNum) {
      this.partyListParams.pageNum = pageNum;
      this.dealGlobalList();
    },
    prevChange() {
      this.partyListParams.pageNum--;
      this.dealGlobalList();
    },
    nextChange() {
      this.partyListParams.pageNum++;
      this.dealGlobalList();
    },
    showAddGlobalControl() {
      this.getKioskPartyList();
      this.selectPartyList = [];
      this.globalControlInfoTips.show = true;
      this.globalControlInfoTips.edit = true;
      this.globalName = this.State.currentPartyInfo.name;
    },
    refreshData() {
      this.selectAll = false;
      this.mutePartyList = [];
      this.dealGlobalList('needGetParticipant');
    },
    moveCallback() {
      this.partyExpand = [];
      this.mutePartyList = [];
      this.movePartyInfo.partyInfo = {};
      this.selectAll = false;
      this.partyList.forEach(item => {
        item.checked = false;
        item.participantList && item.participantList.forEach(item1 => {
          item1.rowCheck = false;
          item1.rowParticipantList && item1.rowParticipantList.forEach(item2 => {
            item2.checked = false;
          });
        });
      });
    },
    defaultSet() {
      if (this.rtc) {
        this.rtc.leave();
        this.rtc = null;
      }
      this.partyListParams = {
        pageNum: 1,
        pageSize: 12,
        globalControlId: ''
      };
      this.partyListInfo = {};
      this.channels = {};
      this.partyList = [];
      this.userInfo = {
        joinCode: ''
      };
    },
    dealGlobalList(needGetParticipant) {
      if (!this.GlobalControlId) return;
      const params = {
        pageNum: this.partyListParams.pageNum,
        pageSize: this.partyListParams.pageSize,
        globalControlId: this.GlobalControlId
      };
      this.axios.post('/partyline-backend/globalControl/getPartyPage', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          res.data.result.list.forEach((item, index) => {
            if (index < 9) {
              item.number = '0' + (index + 1);
            } else {
              item.number = index + 1;
            }
            item.checked = false;
            item.mainWindow = 'Global';
            item.participantList = [];
            item.loading = false;
            item.hasLoadData = false;
          });
          // if (res.data.result.list.length < 100) {
          //   for (var i = 0; i < 100 - res.data.result.list.length; i++) {
          //     const obj = {}
          //     if (9 - res.data.result.list.length > 0) {
          //       obj.number = '0' + (res.data.result.list.length + 1)
          //     } else {
          //       obj.number = res.data.result.list.length + 1
          //     }
          //     obj.checked = false
          //     obj.mainWindow = 'Global'
          //     res.data.result.list.push(obj)
          //   }
          // }
          this.partyListInfo = res.data.result;
          this.partyList = res.data.result.list;
          if (needGetParticipant) {
            this.partyExpand.forEach(partyCode => {
              this.getParticipantList(partyCode, 'clear');
            });
          }
        }
      });
    },
    mainWindowSelectCallback(val) {
      const {
        type,
        sourceType,
        sendBtnColor
      } = val;
      this.sourceType = sourceType;
      this.sendBtnColor = sendBtnColor;
      if (type === 'applyAll') {
        this.executeApplyAll();
      }
    },
    executeApplyAll() {
      this.axios.post('/partyline-backend/globalControl/applyStreamForAll', {
        globalControlId: this.GlobalControlId,
        sourceType: this.sourceType
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    controlMute(type) {
      if (!this.GlobalControlId) return;
      if (type === 'mute') {
        if (this.mutePartyList.length) {
          this.partyList.forEach(item => {
            if (this.mutePartyList.includes(item.partyCode)) {
              item.microphoneStatus = 1;
            }
          });
        }
      } else {
        if (this.mutePartyList.length) {
          this.partyList.forEach(item => {
            if (this.mutePartyList.includes(item.partyCode)) {
              item.microphoneStatus = 0;
            }
          });
        }
      }
      const params = {
        globalControlId: this.GlobalControlId,
        partyCodes: this.mutePartyList.length == this.partyList.length ? [] : this.mutePartyList,
        operateType: type === 'mute' ? 1 : 0
      };
      this.axios.post('/partyline-backend/globalControl/mute', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    controlFullScreen(type) {
      if (!this.GlobalControlId) return;
      this.axios.post('/partyline-backend/globalControl/fullScreen', {
        globalControlId: this.GlobalControlId,
        operateType: type === 'all' ? 1 : 0
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.State.currentPartyInfo.fullScreen = type === 'all' ? 1 : 0;
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    getGlobalAgoraToken(partyCode) {
      // 先掉借口获取加入 agora 的参数
      const params = {
        memberId: handleLocalStorage('get', 'memberId'),
        partyCode: partyCode,
        role: 0,
        type: 3
      };
      this.axios.post('/partyline-backend/party/v2/noLogin/agoraTokenGenerate', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.joinGlobalParty(res.data.result, partyCode);
        }
      });
    },
    async joinGlobalParty(info, partyCode) {
      this.rtc = new AgoraClient(this.callBack);
      const {
        appId,
        tokenCode,
        rtilCode,
        videoQualities
      } = info;
      const params = {
        appId: appId,
        channel: partyCode + '',
        token: tokenCode,
        uid: rtilCode,
        vide0: false,
        audio: false,
        videoConfig: videoQualities,
        publishAudio: false,
        // 始终在realparty内发流
        publishVideo: false // 始终在realparty内发流
      };

      await this.rtc.join(params);
    },
    callBack({
      action,
      payload
    }) {
      switch (action) {
        case 'user-joined':
          this.userJoin(payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.muteAudioOrVideo(action, payload);
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
      }
    },
    operateCallback(obj) {
      const {
        type,
        val
      } = obj;
      if (type === 'fullScreen') {
        this.State.fullScreen = val;
        if (val) {
          document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
        }
      }
    },
    userJoin(payload) {
      this.axios.post(`/partyline-backend/member/noLogin/queryByRtilCode/${payload.id}`).then(res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          const accountId = result.accountId.toLowerCase();
          this.$set(this.devicePlatform, payload.id, result.devicePlatform);
          // this.getNickName(payload)
          const obj = Object.assign({}, this.channels[payload.id]);
          this.$set(this.channels, payload.id, {
            ...payload,
            ...obj,
            tid: accountId
          });
        }
      });
    },
    muteAudioOrVideo(action, payload) {
      const {
        id
      } = payload;
      if (action === 'user-unpublished') {
        this.$set(this.muteAudioObj, id, true);
      } else {
        this.$set(this.muteAudioObj, id, false);
      }
    },
    getNickName({
      id,
      channel
    }) {
      if (!channel) return;
      this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        originRtilCode: id,
        annotation: channel,
        keys: ['nickName', 'tagName', 'noCamera', 'noAudio', 'blockAudio', 'blockVideo', 'flipVideo'],
        marks: [id]
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          // const result = res.data.result[id]
          // this.$set(this.degreeHost, id, result.flipVideo)
          // this.$set(this.behaviorInfo, id, result.nickName)
        }
      });
    },
    subscribeTrack(payload) {
      try {
        const {
          videoTrack,
          audioTrack
        } = payload;
        let obj = {};
        obj = Object.assign({}, this.channels[payload.id], {
          id: payload.id
        }, {
          channel: payload.channel
        });
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        this.$set(this.channels, payload.id, obj);
      } catch (error) {}
    },
    userLeave(payload) {
      this.$set(this.channels, payload.id);
    },
    saveAndGetList(partyCode) {
      this.partyList.forEach(item => {
        if (this.partyExpand.includes(item.partyCode) && !item.hasLoadData) {
          item.hasLoadData = true;
          item.loading = true;
        }
        if (item.hasLoadData && !this.partyExpand.includes(item.partyCode)) {
          item.hasLoadData = false;
          item.loading = false;
        }
      });
      if (this.partyExpand.includes(partyCode)) {
        this.getParticipantList(partyCode, 'clear');
      }
    },
    async getParticipantList(partyCode, type) {
      await this.axios.get(`/partyline-backend/party/noLogin/onlineMembers/${partyCode}`).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          // 2 代表与会者列表
          let list = res.data.result[2];
          const participantList = [];
          this.partyList.forEach(item => {
            if (item.partyCode == partyCode) {
              // 保留之前的 check 状态
              if (list && list.length) {
                if (item.checked) {
                  const rtilCodes = [];
                  let taggerRtilCode = '';
                  list.forEach(item1 => {
                    item1.checked = true;
                    rtilCodes.push(item1.rtilCode);
                    if (item1.tagger) {
                      taggerRtilCode = item1.rtilCode;
                    }
                  });
                  // 由于可能会勾选行而不先获取数据所以还要往 movePartyInfo 里面添加数据用来 move
                  if (!this.movePartyInfo.partyInfo[item.partyCode]) {
                    this.$set(this.movePartyInfo.partyInfo, item.partyCode, {});
                  }
                  this.$set(this.movePartyInfo.partyInfo[item.partyCode], 'rtilCodes', rtilCodes);
                  this.$set(this.movePartyInfo.partyInfo[item.partyCode], 'taggerRtilCode', taggerRtilCode);
                } else {
                  list.forEach(item1 => {
                    item1.checked = false;
                  });
                  if (type === 'clear' && this.movePartyInfo.partyInfo[item.partyCode]) {
                    this.movePartyInfo.partyInfo[item.partyCode].rtilCodes = [];
                    this.movePartyInfo.partyInfo[item.partyCode].taggerRtilCode = '';
                  }
                }
                // 默认一行 5 个
                const number = Math.ceil(list.length / 5);
                for (var i = 0; i < number; i++) {
                  participantList.push({
                    rowChecked: item.checked,
                    rowParticipantList: list.slice(0, 5)
                  });
                  list = list.slice(5);
                }
              }
              item.participantList = participantList;
              item.loading = false;
            }
          });
        }
      });
    },
    async moveParticipants() {
      // 先判断是否有选择过与会者
      const _this = this;
      if (JSON.stringify(_this.movePartyInfo.partyInfo) === '{}') {
        this.$message.warning(this.$t('common.noSelectParticipant'));
        return;
      }
      let hadSelect = false;
      for (const partyCode in _this.movePartyInfo.partyInfo) {
        if (_this.movePartyInfo.partyInfo[partyCode].rtilCodes.length > 0) {
          hadSelect = true;
        }
      }
      if (!hadSelect) {
        this.$message.warning(this.$t('common.noSelectParticipant'));
        return;
      }
      // 有可能只勾选而没有展开(数据是在展开时获取)，所以这时要重新调用接口获取数据
      for (const partyInfo of this.partyList) {
        if (partyInfo.checked) {
          await this.getParticipantList(partyInfo.partyCode);
        }
      }
      this.movePartyInfo.show = true;
    },
    dealParticipantListUI(info) {
      const {
        type
      } = info;
      if (type === 'allCheck') {
        this.dealSelectAll(info);
      } else if (type === 'rowCheck') {
        this.dealRowCheck(info);
      } else if (type === 'partiRowCheck') {
        this.dealPartiRowCheck(info);
      } else {
        this.dealParticipantCheck(info);
      }
      // 处理全选按钮的 UI
      let selectAllFlag = true;
      this.partyList.forEach(item => {
        if (!item.checked) selectAllFlag = false;
      });
      if (selectAllFlag) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    // 全选的处理
    dealSelectAll(info) {
      const {
        val
      } = info;
      this.isSelectAll = val;
      if (val) {
        this.partyList.forEach(item => {
          item.checked = true;
          this.$set(this.movePartyInfo.partyInfo, item.partyCode, {});
          this.$set(this.movePartyInfo.partyInfo[item.partyCode], 'rtilCodes', []);
          this.$set(this.movePartyInfo.partyInfo[item.partyCode], 'taggerRtilCode', '');
          if (!this.mutePartyList.includes(item.partyCode)) this.mutePartyList.push(item.partyCode);
          item.participantList.forEach(item1 => {
            item1.rowChecked = true;
            item1.rowParticipantList.forEach(item2 => {
              item2.checked = true;
              this.movePartyInfo.partyInfo[item.partyCode].rtilCodes.push(item2.rtilCode);
              if (item2.tagger) {
                this.movePartyInfo.partyInfo[item.partyCode].taggerRtilCode = item2.rtilCode;
              }
            });
          });
        });
      } else {
        this.partyList.forEach(item => {
          item.checked = false;
          item.participantList.forEach(item1 => {
            item1.rowChecked = false;
            item1.rowParticipantList.forEach(item2 => {
              item2.checked = false;
            });
          });
        });
        this.mutePartyList = [];
        this.movePartyInfo.partyInfo = {};
      }
    },
    // 选择某一行 party 的处理
    dealRowCheck(info) {
      const {
        val,
        partyCode
      } = info;
      if (val) {
        this.partyList.forEach(item => {
          if (item.partyCode == partyCode) {
            // 如果没有先添加一个
            if (!this.movePartyInfo.partyInfo[partyCode]) {
              this.$set(this.movePartyInfo.partyInfo, partyCode, {});
            }
            if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes) {
              this.$set(this.movePartyInfo.partyInfo[partyCode], 'rtilCodes', []);
              this.$set(this.movePartyInfo.partyInfo[partyCode], 'taggerRtilCode', '');
            }
            if (!this.mutePartyList.includes(item.partyCode)) this.mutePartyList.push(partyCode);
            item.participantList.forEach(item1 => {
              item1.rowChecked = true;
              item1.rowParticipantList.forEach(item2 => {
                item2.checked = true;
                if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(item2.rtilCode)) {
                  this.movePartyInfo.partyInfo[partyCode].rtilCodes.push(item2.rtilCode);
                }
                if (item2.tagger) {
                  this.movePartyInfo.partyInfo[partyCode].taggerRtilCode = item2.rtilCode;
                }
              });
            });
          }
        });
      } else {
        this.partyList.forEach(item => {
          if (item.partyCode == partyCode) {
            if (this.movePartyInfo.partyInfo[partyCode]) this.$delete(this.movePartyInfo.partyInfo, partyCode);
            this.mutePartyList.forEach((infPartyCode, index) => {
              if (infPartyCode == partyCode) {
                this.mutePartyList.splice(index, 1);
              }
            });
            item.participantList.forEach(item1 => {
              item1.rowChecked = false;
              item1.rowParticipantList.forEach(item2 => {
                item2.checked = false;
              });
            });
          }
        });
      }
    },
    // 选择某一个 party 里面一行的处理
    dealPartiRowCheck(info) {
      const {
        val,
        partyCode,
        index
      } = info;
      this.partyList.forEach(item => {
        if (item.partyCode == partyCode) {
          if (!this.movePartyInfo.partyInfo[partyCode]) {
            this.$set(this.movePartyInfo.partyInfo, partyCode, {});
          }
          if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes) {
            this.$set(this.movePartyInfo.partyInfo[partyCode], 'rtilCodes', []);
            this.$set(this.movePartyInfo.partyInfo[partyCode], 'taggerRtilCode', '');
          }
          if (val) {
            this.$set(item.participantList[index], 'rowChecked', true);
            item.participantList[index].rowParticipantList.forEach(item1 => {
              item1.checked = true;
              if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(item1.rtilCode)) {
                this.movePartyInfo.partyInfo[partyCode].rtilCodes.push(item1.rtilCode);
              }
              if (item1.tagger) {
                this.movePartyInfo.partyInfo[partyCode].taggerRtilCode = item1.rtilCode;
              }
            });
          } else {
            this.$set(item.participantList[index], 'rowChecked', false);
            item.participantList[index].rowParticipantList.forEach(item1 => {
              item1.checked = false;
              this.movePartyInfo.partyInfo[partyCode].rtilCodes.forEach((rtilCode, index) => {
                if (this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(rtilCode)) {
                  this.movePartyInfo.partyInfo[partyCode].rtilCodes.splice(index, 1);
                }
              });
              if (this.movePartyInfo.partyInfo[partyCode].taggerRtilCode == item1.rtilCode) {
                this.movePartyInfo.partyInfo[partyCode].taggerRtilCode = '';
              }
            });
          }
          let rowFlag = true;
          let hadSelect = false;
          item.participantList.forEach(item1 => {
            if (!item1.rowChecked) {
              rowFlag = false;
            }
            item1.rowParticipantList.forEach(item2 => {
              if (item2.checked) {
                hadSelect = true;
              }
            });
          });
          // 如果当前 party下一个都没有选择了，则从 movePartyInfo 中移除数据
          if (!hadSelect && this.movePartyInfo.partyInfo[partyCode]) {
            this.$delete(this.movePartyInfo.partyInfo, partyCode);
          }
          if (rowFlag) {
            item.checked = true;
            if (!this.mutePartyList.includes(partyCode)) {
              this.mutePartyList.push(partyCode);
            }
          } else {
            item.checked = false;
            if (this.mutePartyList.includes(partyCode)) {
              this.mutePartyList.forEach((item2, index) => {
                if (item2 == partyCode) {
                  this.mutePartyList.splice(index, 1);
                }
              });
            }
          }
        }
      });
    },
    // 选择某一个 party 某一行的与会者的处理
    dealParticipantCheck(info) {
      const {
        val,
        participant,
        partyCode,
        index
      } = info;
      const rtilCode = participant.rtilCode;
      // 保存要移动的数据
      if (val) {
        if (!this.movePartyInfo.partyInfo[partyCode]) {
          this.$set(this.movePartyInfo.partyInfo, partyCode, {});
        }
        if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes) {
          this.$set(this.movePartyInfo.partyInfo[partyCode], 'rtilCodes', []);
          this.$set(this.movePartyInfo.partyInfo[partyCode], 'taggerRtilCode', '');
        }
        if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(rtilCode)) {
          this.movePartyInfo.partyInfo[partyCode].rtilCodes.push(rtilCode);
        }
        if (participant.tagger) {
          this.$set(this.movePartyInfo.partyInfo[partyCode], 'taggerRtilCode', rtilCode);
        }
      } else {
        if (this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(rtilCode)) {
          this.movePartyInfo.partyInfo[partyCode].rtilCodes = this.movePartyInfo.partyInfo[partyCode].rtilCodes.filter(item => {
            return item != rtilCode;
          });
        }
        if (this.movePartyInfo.partyInfo[partyCode].taggerRtilCode == rtilCode) {
          this.movePartyInfo.partyInfo[partyCode].taggerRtilCode = '';
        }
      }
      // 根据勾选情况看是否要勾选行，和全部的 box
      this.partyList.forEach(info => {
        if (info.partyCode == partyCode) {
          let partiFlag = true;
          let rowFlag = true;
          info.participantList[index] && info.participantList[index].rowParticipantList.forEach(item => {
            if (!item.checked) partiFlag = false;
          });
          if (partiFlag) {
            this.$set(info.participantList[index], 'rowChecked', true);
          } else {
            this.$set(info.participantList[index], 'rowChecked', false);
          }
          let hadSelect = false;
          info.participantList.forEach(item1 => {
            if (!item1.rowChecked) rowFlag = false;
            item1.rowParticipantList.forEach(item2 => {
              if (item2.checked) {
                hadSelect = true;
              }
            });
          });
          // 如果当前 party下一个都没有选择了，则从 movePartyInfo 中移除数据
          if (!hadSelect && this.movePartyInfo.partyInfo[partyCode]) {
            this.$delete(this.movePartyInfo.partyInfo, partyCode);
          }
          if (rowFlag) {
            info.checked = true;
            if (!this.mutePartyList.includes(partyCode)) {
              this.mutePartyList.push(partyCode);
            }
          } else {
            info.checked = false;
            if (this.mutePartyList.includes(partyCode)) {
              this.mutePartyList.forEach((mutePartyCode, index) => {
                if (mutePartyCode == partyCode) {
                  this.mutePartyList.splice(index, 1);
                }
              });
            }
          }
        }
      });
    }
  }
};